import React, { useState } from "react";
import { useI18n } from "../lib/i18n";
import { Globe, Check } from "lucide-react";

export default function LanguageSwitcher() {
  const { lang, setLang, languages } = useI18n();
  const [open, setOpen] = useState(false);
  const current = languages.find((l) => l.code === lang) || languages[0];

  return (
    <div className="relative">
      <button
        onClick={() => setOpen(!open)}
        data-testid="language-switcher-button"
        className="flex items-center gap-2 text-[11px] font-mono uppercase tracking-[0.18em] text-[#a8a29e] hover:text-[#d4af37] transition-colors"
        aria-label="Change language"
      >
        <Globe size={14} />
        <span className="uppercase">{current?.code}</span>
      </button>
      {open && (
        <>
          <div className="fixed inset-0 z-30" onClick={() => setOpen(false)} />
          <div
            data-testid="language-switcher-menu"
            className="absolute right-0 top-full mt-3 w-48 bg-[#141210] border border-white/15 z-40 shadow-xl"
          >
            {languages.map((l) => (
              <button
                key={l.code}
                onClick={() => {
                  setLang(l.code);
                  setOpen(false);
                }}
                data-testid={`language-option-${l.code}`}
                className={`w-full text-left px-4 py-3 flex items-center justify-between hover:bg-white/5 ${
                  lang === l.code ? "text-[#d4af37]" : "text-[#a8a29e]"
                }`}
              >
                <span className="text-sm">{l.name}</span>
                {lang === l.code && <Check size={14} />}
              </button>
            ))}
          </div>
        </>
      )}
    </div>
  );
}
